"use client";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Col, Form, Row} from "react-bootstrap";
import Title from "@/components/Title";
import Select from "react-select";
import Button from "@/components/Button";
import ThemeContainer from "@/components/theme/container";
import Chart from "chart.js";

const Calculator = ({img, text, title, subtitle, stock}) => {
  // investor calculator

  // var CanvasJS = CanvasJSReact.CanvasJS;
  // var CanvasJSChart = CanvasJSReact.CanvasJSChart;
  const [startDate, setStartDate] = useState("");
  const [winWidth, setWinWidth] = useState(true);
  const [can, setCan] = useState(false);
  let totalSum = 0;
  let sumView = 0;
  let weight = 0;
  let portfolio = []; // Empty array to store portfolioReturn values
  let portoflioreturn = 1;
  let cumulativeSum = 0;

  useEffect(() => {
    if (window.innerWidth > 767) {
      setWinWidth(true);
    } else {
      setWinWidth(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth > 767) {
        setWinWidth(true);
      } else {
        setWinWidth(false);
      }
    });
  }, []);

  let name, value;

  const handleDepartment = (e) => {};

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const [dataOption, setDataOption] = useState([]);
  const [MainData, setMainData] = useState([]);
  const [principle, setPriciple] = useState("0");
  const [totalReturn, setTotalreturn] = useState("0");
  const [cagr, seCagr] = useState("0");
  let options = [];
  // Define a state to store the selected options
  const [payment, setPayment] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsYear, setSelectedOptionsYear] = useState([]);
  const handlePayment = (selected) => {
    setPayment(selected);
    clearPaymentError();
  };
  // Function to handle the selected options
  const handleSelection = (selected) => {
    setSelectedOptions(selected);
  };

  const handleSelectionYear = (selected) => {
    setSelectedOptionsYear(selected?.value);
    clearYearError();
  };
  const [paymentError, setPaymentError] = useState("");
  const [yearError, setYearError] = useState("");

  // Function to clear payment error message
  const clearPaymentError = () => {
    if (typeof document !== "undefined") {
      document.getElementById("paymentError").textContent = "";
    }
    setPaymentError("");
  };

  // Function to clear year error message
  const clearYearError = () => {
    if (typeof document !== "undefined") {
      document.getElementById("yearError").textContent = "";
    }
    setYearError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission

    // Initialize portfolio and return value
    let portfolio = [];
    let portoflioreturn = 1;

    // Reset error messages and clear any previous data
    clearPaymentError();
    clearYearError();
    document.getElementById("paymentError").textContent = "";
    document.getElementById("yearError").textContent = "";
    setDataOption([]); // Clear any previous chart data

    // Retrieve form inputs
    const paymentInput = document.querySelector('input[name="payment"]');
    const paymentValue = paymentInput.value;


    const selectedStocks = selectedOptions?.map((option) => option.value);
    const selectedStocksYear = selectedOptionsYear;
    const selectedDate = startDate
      ? formatDate(startDate)
      : formatDate(new Date());

    // Validate payment input
    if (!paymentValue) {
      setPaymentError("Enter starting amount.");
      return;
    }

    // Validate year input
    if (!selectedStocksYear || selectedStocksYear.length < 1) {
      setYearError("Select a year.");
      return;
    }

    try {
      // Set principle amount
      setPriciple(paymentValue);

      // Fetch investor data from the API
      const response = await fetch(
          "https://cms.ucbstock.com.bd//wp-json/custom-api/v1/investor-data-new" +
          `?stock=${selectedStocks}&year=${selectedStocksYear}&payment=${paymentValue}`
      );
      const data = await response.json();

      // Extract required values from the API response
      const mainData = data?.data;
      let final_value =
        data.portfolioValue[data.portfolioValue.length - 1]?.result;
      // let final_value =
      //     data?.portfolioValue[0]?.result;
      let total_value =
        data.totalreturn[data.totalreturn?.length - 1]?.totalreturn;



      // let total_value =
      //     data.totalreturn[0]?.totalreturn;

      let final_value_no_commas = final_value?.replace(/,/g, '');
      let sliced_value = final_value_no_commas?.slice(0, paymentValue?.length);



      let csgr = data.csgr[data.csgr?.length - 1]?.csgr;
      // Fetch investor data from the API
      const updatedDataOption = [];
      // Prepare updated chart data
      data.portfolioValue?.map((e, index) => {
        const dateParts = e?.year.split("-");
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1;
        const dateValue = new Date(e?.year);

        updatedDataOption.push({ x: dateValue, y: parseFloat(e?.result) });
      });

      updatedDataOption.sort((a, b) => a.date - b.date);

      // Update chart data
      setDataOption(updatedDataOption);

      // Update the result HTML with the calculated values
      const resultElement = document.querySelector(".result");
      if (resultElement) {
        const selectedOptionsList = selectedOptions
          ?.map((e) => e?.label)
          .join(", ");
        const lastIndex = selectedOptionsList.lastIndexOf(",");
        const formattedOptionsList =
          lastIndex === -1
            ? selectedOptionsList
            : `${selectedOptionsList.slice(
                0,
                lastIndex
              )} and ${selectedOptionsList.slice(lastIndex + 1)}`;

        resultElement.innerHTML = `
        <div class="result-wrp">
          <p>If you have invested equally in
            <span>${formattedOptionsList}</span>, <span>${selectedStocksYear}</span> years ago, today you would have had BDT</p>
          <div class="result-wrap-block">
            <ul>
              <li>
                <p>Total Return</p>
                <p class="resutl">${total_value.split(",")[0].slice(0, 2) + "%"}</p>
              </li>
              <li>
                <p>CAGR</p>
                <p class="resutl">${csgr}</p>
              </li>
              <li>
                <p>Increment</p>
                <p class="resutl">${sliced_value}</p>
              </li>
            </ul>
          </div>
        </div>
      `;
      }

      setCan(true);
      final_value = null;
    } catch (error) {
      console.error("Failed to fetch data from the API:", error); // Handle error
    }
  };

  useEffect(() => {
    // Check if dataOption exists and has a length property
    if (dataOption && dataOption.length > 0) {
      function formatDate(dateString) {
        const date = new Date(dateString);
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${month} ${year}`;
      }

      // Sort dataOption by date
      const sortedData = dataOption.sort(
        (a, b) => new Date(a.x) - new Date(b.x)
      );

      // Calculate intervals based on the month of each data point
      const intervals = [];
      for (let i = 0; i < sortedData.length - 1; i++) {
        const currentDate = new Date(sortedData[i].x);
        const nextDate = new Date(sortedData[i + 1].x);
        const monthDiff =
          (nextDate.getFullYear() - currentDate.getFullYear()) * 12 +
          nextDate.getMonth() -
          currentDate.getMonth();
        if (monthDiff >= 6) {
          intervals.push(formatDate(sortedData[i].x));
        }
      }

      // Filter original dataset and create a new dataset with modified x values
      const newData = dataOption.map((item) => {
        return { x: formatDate(item.x), y: item.y };
      });

      (async function () {
        const data = newData;

        new Chart(document.getElementById("line-chart"), {
          type: "bar",
          data: {
            labels: data.map((row) => row.x),
            datasets: [
              {
                backgroundColor: "#E62E43",
                borderColor: "#3182ce",
                label: "Investment Calculator",
                data: data.map((row) => row.y),
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontSize: 12, // Adjust the font size here
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    fontSize: 14, // Adjust the font size here
                  },
                },
              ],
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return "Portfolio Price: " + tooltipItem.yLabel;
                },
              },
            },
            legend: {
              labels: {
                fontSize: 24, // Adjust the font size for the legend label
                fontColor: "#3c3c3b", // Change the font color
                fontStyle: "bold", // Change the font weight
              },
            },
          },
        });
      })();
    }
  }, [dataOption]);

  const stockColumns = stock?.stock_columns || []; // Ensure it's an array

  const DropdownOption = stockColumns
      .filter(stockName => stockName !== "Date") // Remove items named "Date"
      .map(stockName => {
        return {
          value: stockName, // Converting to lowercase for consistency
          label: stockName,  // Converting to uppercase for display
        };
      });




  const DropdownOptionYear = [
    { value: "2", label: "2 Years" },
    { value: "5", label: "5 Years" },
    { value: "10", label: "10 Years" },
  ];

  const CustomMultiValue = ({ data }) => (
    <div>
      <span>{data.label}</span>
      <PlusIcon
        style={{
          marginLeft: "5px",
          verticalAlign: "middle",
          marginRight: "5px",
          top: "-2px",
          position: "relative",
        }}
      />
    </div>
  );

  const CustomMultiValueLabel = ({ data }) => (
    <div>
      <span>{data.label}</span>
      <PlusIcon
        style={{
          marginLeft: "5px",
          verticalAlign: "middle",
          marginRight: "5px",
          top: "-2px",
          position: "relative",
        }}
      />
    </div>
  );

  return (
    <StyledOverview className="calculator pt-200 ">
      <div className="investor_calculator">
        <ThemeContainer
          colProps={{ md: 12 }}
          colClassName={"modal-data__content"}
        >
          <Row class={"row"}>
            <Col className={"form"} md={6}>
              <Title margin={"0 0 40px 0"} text={"Investment Calculator"} />

              <div className="form-wrapper-all">
                <Form
                  onSubmit={handleSubmit}
                  method="post"
                  enctype="multipart/form-data"
                >
                  <Row>
                    <Form.Group className="col-md-12 pb-30 form-wrapper">
                      <Form.Control
                        className={"form-control-lg"}
                        type="number"
                        name="payment"
                        placeholder="Starting Amount"
                        required
                        onChange={handlePayment}
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 12);
                        }}
                      />
                      <div
                        id="paymentError"
                        className="calculator-error-message"
                      >
                        {paymentError}
                      </div>
                    </Form.Group>

                    <Form.Group className="col-md-12 pb-30 form-wrapper">
                      <Select
                        isMulti
                        placeholder={"Stock"}
                        onChange={handleSelection} // replace with your selection handler function
                        styles={{
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            transform:
                              state.selectProps.menuIsOpen && "rotate(180deg)",
                          }),
                        }}
                        classNamePrefix={"react-select"}
                        className={"form-select"}
                        isSearchable={false}
                        isOptionDisabled={() => selectedOptions.length >= 5}
                        options={DropdownOption} // replace with your dropdown options
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "#e9e9e9",
                            primary: "black",
                          },
                        })}
                      />
                      <p className={"hints"}>Select up to 5 Stocks</p>
                    </Form.Group>

                    <Form.Group className="col-md-12 pb-30 form-wrapper last">
                      <Select
                        placeholder={"Year"}
                        name="year"
                        onChange={handleSelectionYear} // replace with your selection handler function
                        styles={{
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            transform:
                              state.selectProps.menuIsOpen && "rotate(180deg)",
                          }),
                        }}
                        classNamePrefix={"react-select"}
                        className={"form-select"}
                        options={DropdownOptionYear} // replace with your dropdown options
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "#e9e9e9",
                            primary: "black",
                          },
                        })}
                      />
                      <div id="yearError" className="calculator-error-message">
                        {yearError}
                      </div>
                    </Form.Group>

                    <div className="clear"></div>

                    <Form.Group
                      className="col-xl-6 widthHalf"
                      onClick={handleSubmit}
                    >
                      <Button
                        margin={"0 40px 0 0"}
                        padding={"0"}
                        hoverColor={"#3C3C3B"}
                        hoverBackground={"#3C3C3B"}
                        width={"auto"}
                        text={"Calculate"}
                        classname={"col-md-6"}
                      />
                    </Form.Group>
                  </Row>
                </Form>
              </div>
            </Col>

            <Col md={{ span: 5, offset: 1 }} id={"result"} className={"result"}>
              <div className="result-wrp"></div>
            </Col>
          </Row>
          <Row className={"desktop-view-blog"}>
            {dataOption?.[0] && (
              <Col md={12}>
                <br />
                <div className="relative chart-container h-350-px">
                  <canvas id="line-chart"></canvas>
                </div>
              </Col>
            )}
          </Row>
        </ThemeContainer>
      </div>
    </StyledOverview>
  );
};

const StyledOverview = styled.section`
  padding-bottom: 120px;
  background: white;
  .react-select__menu {
    background: white !important;

    li {
      font-size: 14px !important;
      line-height: 20px !important;
      font-weight: 400 !important;
    }

    a {
      font-size: 14px !important;
      line-height: 20px !important;
      font-weight: 400 !important;
    }
  }

  .chart-container {
    height: 90vh;
    @media (max-width: 767px) {
      height: 400px;
    }
  }

  .title {
    h2 {
      font-size: 36px;
      line-height: 40px;
      letter-spacing: 0.5px;
      font-family: "Butler";
    }
  }

  .form-wrapper {
    position: relative;

    .calculator-error-message {
      position: absolute;
      bottom: 15px;
    }

    &.last {
      .calculator-error-message {
        bottom: 20px;
      }

      .form-select {
        margin-bottom: 40px;
      }
    }
  }

  .calculator-error-message {
    color: red;
    font-size: 12px;
  }

  .desktop-view {
    display: flex;
  }

  .desktop-view-blog {
    display: block;
  }

  .mobile-view {
    display: none;
  }

  .form-wrapper-all {
    .form-control {
      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: #191919 !important;
      margin-bottom: 35px !important;

      &::placeholder {
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        color: #191919 !important;
      }
    }
  }

  @media (max-width: 767px) {
    .desktop-view,
    .desktop-view-blog {
      //display: none;
      flex-direction: column;

      .col-md-6 {
        max-width: 100%;
        width: 100%;
      }
    }

    .mobile-view {
      display: block;
    }
  }

  .hints {
    font-size: 12px !important;
    color: rgba(25, 25, 25, 0.5) !important;
    margin-bottom: 25px !important;
    margin-top: 5px;
    font-weight: 400;
  }

  .react-select__value-container {
    div:nth-of-type(5) {
      svg {
        display: none;
      }
    }
  }

  .custom {
    border: 1px solid black;
    border-collapse: collapse;

    td,
    th,
    td {
      border: 1px solid black;
    }
  }

  .modal-data__content {
    border-top: none;
  }

  .dc-btn a:hover {
    span {
      color: white;
    }
  }

  .form {
    input[type="Date"] {
      color: #3c3c3b;
    }

    .react-datepicker-wrapper {
      width: 100%;
    }

    .react-datepicker-popper[data-placement^="bottom"]
      .react-datepicker__triangle::before {
      left: -25px;
    }

    .react-datepicker-popper[data-placement^="bottom"]
      .react-datepicker__triangle::after {
      left: -25px;
    }

    .react-datepicker__input-container {
      width: 100%;

      input {
        width: 100%;

        font-size: 14px;
        font-weight: 500;
        color: #3c3c3b;
        border-right: none;
        border-left: none;
        border-top: none;
        outline: none;
        box-shadow: none;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 10px;
        padding-top: 0;
        height: 33px;
        margin-bottom: 25px;
        border-bottom: 1px solid rgba(60, 60, 59, 0.5);

        &::placeholder {
          font-size: 14px;
          font-weight: 500;
          color: rgba(60, 60, 59, 0.5);
        }
      }
    }

    .form-control {
      font-size: 14px;
      font-weight: 500;
      color: #3c3c3b;
      border-right: none;
      border-left: none;
      border-top: none;
      outline: none;
      box-shadow: none;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 10px;
      padding-top: 0;
      height: 33px;
      margin-bottom: 25px;
      border-bottom: 1px solid rgba(60, 60, 59, 0.5);

      &::placeholder {
        font-size: 14px;
        font-weight: 500;
        color: rgba(60, 60, 59, 0.5);
      }
    }

    .react-select__indicator {
      padding: 0;
    }

    .react-select__placeholder {
      margin: 0;
      padding: 0;
      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: #191919 !important;
    }

    .react-select__control {
      border-bottom: 1px solid rgba(60, 60, 59, 0.5);
      margin-bottom: 0px;
      border-right: none;
      border-left: none;
      border-top: none;
      outline: none;
      box-shadow: none;
      padding-left: 0;
      padding-right: 0;

      .react-select__indicator-separator {
        display: none;
      }

      .react-select__input-container {
        padding: 0;
        margin: 0;
      }

      .react-select__single-value {
        margin: 0;
        padding: 0;
        font-size: 14px;
        font-weight: 500;
        color: #3c3c3b;
      }

      .react-select__value-container {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .result-wrp {
    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #191919;

      span {
        color: #e62e43;
        font-weight: bold;
      }

      margin-bottom: 40px;
    }

    .result-wrap-block {
      background: #191919;

      ul {
        display: flex;
        flex-direction: column;
        padding: 30px 0;

        li {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          margin-bottom: 15px;
          padding-bottom: 15px;
          padding-left: 30px;
          padding-right: 30px;

          &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
          }

          &:last-child {
            border-bottom: none;
          }

          p {
            margin: 0;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: rgba(255, 255, 255, 1);

            &.resutl {
              margin: 0;
              font-size: 32px;
              font-weight: 500;
              line-height: 36px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .simplebar-content {
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .react-select__multi-value {
    background: #f1eee9 !important;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }

  @media (max-width: 767px) {
    .scroll-div {
      padding: 0 !important;
    }

    .modal-data {
      margin-top: 0 !important;
    }

    .modal-close {
      right: 15px !important;
      //top: 0px !important;
    }

    .result {
      margin-top: 60px;
    }

    .invest-content {
      padding-top: 60px;
      margin-bottom: 60px;
    }

    .modal-data__content {
      margin-top: 60px !important;
      padding: 0 15px !important;
    }
  }
`;

export default Calculator;
